module.exports = {
    userauth: 'User Authority',
    mediasource: 'Media Source',
    publicsource: 'Public Source',
    publicresources: 'Resources',
    whatsnewsetting: 'What\'s New',
    exhibitionWall: 'Exhibition Wall',
    account: 'Account Information',
    helpcenter: 'Help Center',
    feedback: 'Feedback',
    companyName: 'Company Name',
    activeServicesModule: 'Active Services Module',
    nickName: 'Nick Name',
    enterNickNameTip: 'Please enter Nick Name',
    serviceTeam: 'Service Team',
    SubscriptionSetting:'SubscriptionSetting',
    apiDocuments: 'API Documents',
    pskul:'Please input KOL link',
    qualityManagement: 'Quality Management',
    day:'Day',
    email_acount:'Email(User name)',
    mustwrite:'can not be empty',
    event_cost:'Event cost',
    createNew:'Create a New Advertiser',
    events:'Event cost',
    a_cost:'Event cost',
    cost:'Event cost',
    en_Case:'English Case',
    productUpdates: 'Product Updates',
    operatingManuals: 'Operating Manuals',
    api: 'API Documents',
    quality: 'Quality Management',
    product: 'Product Updates',
    sinEvent:"This campaign is already used in event setting",
    sinSet:"This campaign is already used in the install setting",
    operating: 'Operating Manuals',
    norepeat:'Pkgname cannot be repeated, please fill in again',
    all: 'All',
    fast: 'Fast',
    influencer_name:'Influencer',
    faq: 'Faq',
    open:'Open',
    close:'Close',
    changeTabletips:'Table changed fail',
    TimeDates:'Time',
    read: 'Read',
    unread: 'Unread',
    accountAuthority:'Account Authority',
    tips:'The advertiser has already chosen. Please reselect!',
    empty:'The advertiser and module cannot be empty',
    Advertiser:'Advertiser',
    fusionAdvertiser:'Fusion Adv',
    logo:'Logo',
    BusinessType:'BusinessType',
    Operation:'Operation',
    Role:'Role',
    username:'User name',
    Publicsetting:'Public Setting',
    advName:'Advertiser Name',
    seemore:'See More',
    Report:'Report',
    eng:'English',
    ch:'Chinese',
    En:'En',
    Cn:'Cn',
    Reports_en:'English Report',
    Report_en:'English Report',
    ReleaseDate:'Release Date',
    Type:'Type',
    Launch:'Launch',

    Modules:'Modules',
    Module:'Module',
    ProfilePhoto:'Profile Photo',
    Email:'Email',
    Name:'Name',
    Account:'Account',
    Position:'Position',

    Title:'Title',
    Title_en:'English Title',

    Abstract:'Abstract',
    Operatedate:'Operate Date',
    Uploadtime:'Upload time',
    Case:'Case',
    Format:'Format',
    date:'Date',
    No:'No.',
    Account:'Account',

    OriginalAffID:'Original Aff ID',
    Status:'Status',
    AffID:'Aff ID',
    Percent:'Percent',
    AffName:'Aff Name',

    ARPU: "ARPU",
    Login: "Login",
    Login_Rate: "Login Rate",
    Pay: 'PAY',
    Pay_Rate: 'Pay Rate',
    Purchase: "Purchase",
    Retention: "Retention",
    rentention:'Retention',
    roi:'ROI',
    Retention_Rate: "Retention Rate",
    adv_id: "Advertiser",
    app_name: "App Name",
    click: 'Click',
    clicks: 'Click',
    Click:'Click',
    conversion: 'Conversion',
    Conversion:'Conversion',
    i_a_cost : "Cost",

    country: "Country",
    cr: 'CR',
    ctr: 'CTR',
   
    impression: 'Impression',
    impressions: 'Impression',
    ivr: 'IVR',
    media_source: "Media Source",
    platform: "android",
    revenue: "Revenue",
    Revenue:'Revenue',
    time_zone: "Time Zone",

    total:'Total',

    advertiser:'Advertiser',
    campaign: "Campaign",
    campaignId_new:'Campaign',
    cpm: "CPM",
    influencer: "Influencer",
    launch_time: "Launch-in time",
    platform: "Platform",
    view_count: "View counts",

    Click:'Click',
    Order:'Order',
    order:'Order',
    Cost:'Cost',
    Percentage:'Percentage',
    SubscriptionSetting:'Subscription Setting',
    Instructionsforuse:'Instructions for use',
    AboutYeahagency:'About Yeahgrowth',
    profit_rate:'Profit rate',
    profit:'Profit',
    affiliate_cost:'AFF cost',
    QuickStart:'Quick Start',
    userSetting:'User Setting',
    ProductUpdates:'Product Updates',
    QualityManagement:'Quality Management',
    APIDocuments:"API Documents",
    download:'Download',
    DAU:'DAU(Last day)',
    Downloads:'Downloads',
    Pkg_name:'Pkg_name',
    mediaNull:'MediaSource cannot be empty',
    priceNull:'Price cannot be empty',
    Results:'Results',
    shadow_aff_id: 'Media Source ID',
    shadow_aff_name: 'Media Source',
    local_cost: 'Cost(Local Currency)',
    currency:'Currency',
    usacost: 'Cost(USD)',
    All:'All',
    Active:'Active',
    Close:'Close',
    Install:'Install',
    Retargeting:'Retargeting',
    Clicks:'Click',
    cvr:'CVR',
    CVR:'CR',
    a_count:'Event',
    es:'Event Setting',
    pkgchanged:'The pull status of the pkg has changed',
    is:'Install Setting',
    retargetingSetting: 'Retargeting Setting',
    Event:'Event',
    events:"Event",
    installs:'Install',
    Campaign:'Campaign',
    ROAS:'ROAS',
    imp:'IMP',
    Timerange:'Time range',
    Product:'Product',
    Creative:'Creative',
    Format:'Format',
    Createtime:'Create Time',
    Rdtools:'R&d Tools',
    cost$:'Cost ($)',
    view_count2:'View counts(Like)',
    Date:'Date',
    Upload_file:'Upload Report',
    Upload_cover:'Upload Picture',
    Select:'Select',
    moduleSetting:'Module Setting',
    influencerName:'Influencer name',
    influencerlink:'Influencer profile link',
    camName:'Campaign name',
    camLink:'Campaign link',
    psa:'Please select advertiser',
    psp:'Please select platform',
    pic:'Please input campaign',
    pii:'Please input influencer',
    pst:'Please select Type',
    scn:'Search case name',
    password:'Password',
    bussinessType:'Business Type',
    pia:'Please input account',
    btir:'Business type is required',
    accounType:'Account Type',
    global:'Global',
    pkg:'PKG',
    activities:'Activities',
    awards:'Awards',
    psyp:'Please select your position',
    psyn:'Please select your account',
    psye: 'Please input your name',
    psym:'Please select your module',
    Upload:'Upload',
    pece:'Please enter a corrent email',
    ps:'Please select',
    About:'About',
    Quick:'Quick',
    Instruction:'Instruction',

    AdvId:'Advertiser name',
    appName:'App name',
    timezone:'Time Zone',
    MediaSource:'MediaSource',
    Country:'Country',
    roas:'Roas',
    rosa:'Roas',
    systemManagement: 'System Setting',
    clientInformation: 'Client Information',
    clientAccountSetting: 'Client Account',
    teamServiceSetting: 'Team Service',
    businessAuthoritySetting: 'Business Authority',
    teamMembers: 'Team Members',
    noupload:'No photos has been uploaded yet',
    BisicSetting:'Basic',
    customerProduct:'Product',
    CustomerAccount:'Account',
    company:'Company Name',
    status:'Status',
    phone:'Contact Information',
    createDate:'CreateDate',
    updateDate:'UpdateDate',
    hangye:'Trade',
    address:'Registered Address',
    website:'Company Website',
    customer:'Customer',
    productType:'Business',
    productName:'Product Name',
    productPic:'Product Picture',
    packageName:'Package Name',
    appName:'App Name',
    platformFE:'Plat Support',
    applogos:'App Logo',
    firstName:'First Name',
    docedit:'Document Setting',
    lastName:'Last Name',
    email:'Email',
    Openservice:'Open Service',
    productlimits:'Product',
    accountType:'Account Type',
    orderId:'Contract No',
    associatedAccount:'Adv ID',
    pi:'Please input ',
    name:'Name',
    pro:'Product',
    accou:'Account',
    pczs:'Please choose open service first',
    menuAuth: 'Menu Auth',
    apiAuth: 'Api Auth',
    selectfeew:'Please select Customer',
    isof:'of ',
    dateEmpty:'Content Empty',
    docedit:'Document setting',
    delete_item:'Are you sure to delete this file or chapter?',
    sure:'OK',
    cancel:'Cancel',
    folder:'Chapter',
    file:'File',
    tagsetting:'Tag Setting',
    authorityseting:'Share',
    submit:'Submit',
    save:'Save',
    pwct:'Please fill in the Chinese title',
    pwet:'Please fill in the English title',
    createman:'Creator',
    tipssave:'Friendly reminder',
    needsave:'The contents of the file have been modified. Do I need to save it?',
    Signing : 'Signing account',
    Sub : 'Sub account',
    Main :'Main account',
    re_engagement: 'Re-Engagement',
    re_attribution: 'Re-Attribution',
    re_setting_pwd:'Reset password',
    checktip:'Clicking check will automatically fill in the following information',
    Check:'Check',
    productPicin:'Please upload pictures',
    errorpkg:'Failed to get information from app store, please check app name',
    delbasic:'Deleting this record will also delete related products and customer accounts. Please confirm the deletion.'
}



// WEBPACK FOOTER //
// ./src/i18n/modules/authority/en.js